import clsx from "clsx";
import { Text } from "./base";

type FineTuningJobStatusPillProps = {
  status: string;
  phase?: string | null;
};

const STATUS_LABELS: Record<string, string> = {
  validating_files: "Validating",
  queued: "Queued",
  provisioning: "Provisioning",
  running: "Running",
  succeeded: "Succeeded",
  failed: "Failed",
  cancelled: "Cancelled",
};

// SkyPilot sub-state, shown under provisioning so "running" means actually training.
const PHASE_LABELS: Record<string, string> = {
  PENDING: "Pending",
  SUBMITTED: "Submitted",
  STARTING: "Starting",
  RECOVERING: "Recovering",
  RUNNING: "Running",
};

export const FineTuningJobStatusPill = ({ status, phase }: FineTuningJobStatusPillProps) => {
  const label = STATUS_LABELS[status] ?? status;
  const detail = status === "provisioning" && phase ? ` · ${PHASE_LABELS[phase] ?? phase}` : "";
  return (
    <Text
      className={clsx(
        "w-auto px-2 py-0.5 rounded-full text-xs whitespace-nowrap",
        status === "succeeded" && "bg-success/10 dark:bg-success/20 text-success-dark dark:text-success-light",
        status === "running" && "bg-info/10 dark:bg-info/20 text-info-dark dark:text-info-light",
        (status === "queued" || status === "validating_files" || status === "provisioning") &&
          "bg-yellow-100 dark:bg-yellow-900/40 text-yellow-800 dark:text-yellow-300",
        status === "failed" && "bg-error/10 dark:bg-error/20 text-error-dark dark:text-error-light",
        status === "cancelled" && "bg-gray-100 dark:bg-gray-700/40 text-gray-700 dark:text-gray-300",
      )}
    >
      {label}
      {detail}
    </Text>
  );
};
